import {
  faArrowUp,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faColumns,
  faFilter,
  faKey,
  faLayerGroup,
  faPen,
  faPlus,
  faSave,
  faSearch,
  faStepBackward,
  faStepForward,
  faTimes,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import intl from 'localization/components'

// Icon size for table actions
const iconStyle = { fontSize: '14px' }
const smallIconStyle = { fontSize: '12px' }

export const localization = (messages) => {
  return {
    pagination: {
      firstAriaLabel: messages[intl.generic('first-page')],
      firstTooltip: messages[intl.generic('first-page')],
      previousAriaLabel: messages[intl.generic('previous-page')],
      previousTooltip: messages[intl.generic('previous-page')],
      nextAriaLabel: messages[intl.generic('next-page')],
      nextTooltip: messages[intl.generic('next-page')],
      lastAriaLabel: messages[intl.generic('last-page')],
      lastTooltip: messages[intl.generic('last-page')],
      labelRowsSelect: messages[intl.generic('rows')],
    },
    toolbar: {
      searchTooltip: messages[intl.searchBusiness('search-field')],
      searchPlaceholder: messages[intl.searchBusiness('search-field')],
      searchAriaLabel: messages[intl.searchBusiness('search-field')],
      clearSearchAriaLabel: '',
    },
    header: {
      actions: messages[intl.generic('actions')],
    },
    body: {
      addTooltip: messages[intl.generic('add')],
      editTooltip: messages[intl.generic('edit')],
      deleteTooltip: messages[intl.riskMonitoringNew('delete-items')],
      editRow: {
        deleteText: messages[intl.settings('are-you-sure-delete-user')],
        cancelTooltip: messages[intl.confirmAction('cancel')],
        saveTooltip: messages[intl.confirmAction('confirm')],
      },
    },
  }
}

const CheckIcon = () => <FontAwesomeIcon icon={faCheck} style={iconStyle} />
const DetailPanelIcon = () => <FontAwesomeIcon icon={faChevronRight} style={smallIconStyle} />
const DeleteIcon = () => <FontAwesomeIcon icon={faTrash} style={iconStyle} />
const ExportIcon = () => <FontAwesomeIcon icon={faSave} style={iconStyle} />
const FilterIcon = () => <FontAwesomeIcon icon={faFilter} style={iconStyle} />
const FirstPageIcon = () => <FontAwesomeIcon icon={faStepBackward} style={iconStyle} />
const LastPageIcon = () => <FontAwesomeIcon icon={faStepForward} style={iconStyle} />
const NextPageIcon = () => <FontAwesomeIcon icon={faChevronRight} style={smallIconStyle} />
const PreviousPageIcon = () => <FontAwesomeIcon icon={faChevronLeft} style={smallIconStyle} />
const SearchIcon = () => <FontAwesomeIcon icon={faSearch} style={iconStyle} />
const ThirdStateCheckIcon = () => <FontAwesomeIcon icon={faTrash} style={iconStyle} />
const AddIcon = () => <FontAwesomeIcon icon={faPlus} style={iconStyle} />
const SortArrowIcon = ({ className }) => (
  <FontAwesomeIcon icon={faArrowUp} className={className} style={smallIconStyle} />
)
const ClearIcon = () => <FontAwesomeIcon icon={faTimes} style={iconStyle} />
const EditIcon = () => <FontAwesomeIcon icon={faPen} style={iconStyle} />
const ViewColumnIcon = () => <FontAwesomeIcon icon={faColumns} style={iconStyle} />
const DeleteApiIcon = () => <FontAwesomeIcon icon={faLayerGroup} style={iconStyle} />
const UserApiToken = () => <FontAwesomeIcon icon={faKey} style={iconStyle} />

export const icons = {
  Check: CheckIcon,
  DetailPanel: DetailPanelIcon,
  Delete: DeleteIcon,
  Export: ExportIcon,
  Filter: FilterIcon,
  FirstPage: FirstPageIcon,
  LastPage: LastPageIcon,
  NextPage: NextPageIcon,
  PreviousPage: PreviousPageIcon,
  Search: SearchIcon,
  ThirdStateCheck: ThirdStateCheckIcon,
  Add: AddIcon,
  SortArrow: SortArrowIcon,
  Clear: ClearIcon,
  ResetSearch: ClearIcon,
  Edit: EditIcon,
  ViewColumn: ViewColumnIcon,
  DeleteApi: DeleteApiIcon,
  UserApiToken,
}
